import { ActionRequest } from './BaseActionModel';

export enum GroupAuditAction {
	VIEW = 'view',
	READ_DISCUSSION = 'read_discussion',
	HOME_VIEW = 'home_view',
	VIEW_CONTENT_PAGE = 'view_content_page',
	VIEW_CUSTOM_PAGE = 'view_custom_page',
	VIEW_EVENTS_LIST_PAGE = 'view_events_list_page',
	VIEW_DISCUSSION_CREATE_PAGE = 'view_discussion_create_page',
	VIEW_DISCUSSION_EDIT_PAGE = 'view_discussion_edit_page',
	READ_NOTE_PAGE = 'read_note_page',
	VIEW_NOTE_LIST_PAGE = 'view_note_list_page',
	VIEW_NOTE_CREATE_PAGE = 'view_note_create_page',
	VIEW_NOTE_EDIT_PAGE = 'view_note_edit_page',
	VIEW_EVENT_PAGE = 'view_event_page',
	VIEW_FILE = 'view_file',
	VIEW_LINK = 'view_link',
	VIEW_GROUP_DETAILS_PAGE = 'view_group_details_page',
	VIEW_GROUP_TERMS = 'view_group_terms',
	VIEW_GROUP_MEMBER_PAGE = 'view_group_member_page',
	VIEW_SHARE_FILE_PAGE = 'view_share_file_page',
}

export type SimpleAuditAction = GroupAuditAction.VIEW
	| GroupAuditAction.HOME_VIEW
	| GroupAuditAction.VIEW_CUSTOM_PAGE
	| GroupAuditAction.VIEW_CONTENT_PAGE
	| GroupAuditAction.VIEW_EVENTS_LIST_PAGE
	| GroupAuditAction.VIEW_DISCUSSION_CREATE_PAGE
	| GroupAuditAction.VIEW_NOTE_LIST_PAGE
	| GroupAuditAction.VIEW_NOTE_CREATE_PAGE
	| GroupAuditAction.VIEW_EVENT_PAGE
	| GroupAuditAction.VIEW_GROUP_DETAILS_PAGE
	| GroupAuditAction.VIEW_GROUP_TERMS
	| GroupAuditAction.VIEW_SHARE_FILE_PAGE;
export type SimpleActionRequest = ActionRequest<SimpleAuditAction, null>;

export interface MessageActionMetadata {
	// Hashed message ID
	messageId: string;
}
export type MessageAuditAction = GroupAuditAction.VIEW_DISCUSSION_EDIT_PAGE
	| GroupAuditAction.READ_NOTE_PAGE
	| GroupAuditAction.VIEW_NOTE_EDIT_PAGE;
export type MessageActionRequest = ActionRequest<MessageAuditAction, MessageActionMetadata>;

export interface ContentActionMetadata {
	// Hashed message ID
	contentId: string;
}
export type ContentAuditAction = GroupAuditAction.VIEW_FILE
	| GroupAuditAction.VIEW_LINK;
export type ContentActionRequest = ActionRequest<ContentAuditAction, ContentActionMetadata>;

export interface EventActionMetadata {
	// Hashed message ID
	eventId: string;
}
export type EventAuditAction = GroupAuditAction.VIEW_EVENT_PAGE;
export type EventActionRequest = ActionRequest<EventAuditAction, EventActionMetadata>;

export type GroupAuditActionRequest = SimpleActionRequest
	| MessageActionRequest
	| ContentActionRequest
	| EventActionRequest;
